export const common = {
  // Header
  header_tagline: 'Uw vertrouwde IT-partner sinds 2025',
  language_english: 'English',
  language_dutch: 'Nederlands',
  account: 'Account',
  cart: 'Winkelwagen',
  request_quote: 'Offerte Aanvragen',
  
  // Navigation
  nav_hardware: 'Hardware',
  nav_software: 'Software',
  nav_it_services: 'IT Diensten',
  nav_it_solutions: 'IT Oplossingen',
  nav_generative_ai: 'Generatieve AI',
  nav_support: 'Ondersteuning',
  nav_about: 'Over Ons',
  
  // Hardware Categories
  hardware_computing: 'Computing',
  hardware_networking: 'Netwerken',
  hardware_laptops_desktops: 'Laptops & Desktops',
  hardware_servers_storage: 'Servers & Opslag',
  hardware_workstations: 'Werkstations',
  hardware_components: 'Componenten',
  hardware_routers_switches: 'Routers & Switches',
  hardware_wireless_solutions: 'Draadloze Oplossingen',
  hardware_security_appliances: 'Beveiligingsapparatuur',
  hardware_network_infrastructure: 'Netwerkinfrastructuur',
  hardware_wifi_wireless: 'WiFi en draadloze systemen',
  hardware_network_security: 'Netwerkbeveiligingshardware',
  
  // Software Categories
  software_business: 'Zakelijke Software',
  software_security_utilities: 'Beveiliging & Hulpprogramma\'s',
  software_microsoft_365: 'Microsoft 365',
  software_adobe_creative: 'Adobe Creative Cloud',
  software_accounting_erp: 'Boekhouding & ERP',
  software_antivirus: 'Antivirus & Beveiliging',
  software_backup: 'Back-up Oplossingen',
  software_operating_systems: 'Besturingssystemen',
  
  // IT Services Categories
  services_core: 'Kerndiensten',
  services_managed: 'Beheerde Diensten',
  services_integration: 'Integratie & Configuratie',
  services_cloud: 'Cloud Diensten',
  services_consulting: 'IT Consulting',
  services_project_management: 'Projectmanagement',
  services_managed_it: 'Beheerde IT Diensten',
  
  // IT Solutions Categories
  solutions_enterprise: 'Enterprise Oplossingen',
  solutions_security: 'Beveiligingsoplossingen',
  solutions_enterprise_software: 'Enterprise Software Implementatie',
  solutions_digital_transformation: 'Digitale Transformatie',
  solutions_infrastructure: 'Infrastructuur Optimalisatie',
  solutions_cyber_security: 'Cyberbeveiliging',
  
  // AI Categories
  ai_consulting: 'AI Consulting',
  ai_solutions: 'AI Oplossingen',
  ai_machine_learning: 'Machine Learning',
  ai_automation: 'AI Automatisering & Integratie',
  ai_computer_vision: 'Computer Vision Oplossingen',
  ai_conversational: 'Conversationele AI Systemen',
  
  // Footer
  footer_quick_links: 'Snelle Links',
  footer_products: 'Producten',
  footer_services: 'Diensten',
  footer_company: 'Bedrijf',
  footer_legal: 'Juridisch',
  footer_newsletter: 'Nieuwsbrief',
  footer_newsletter_text: 'Blijf op de hoogte van onze laatste producten en diensten',
  footer_subscribe: 'Abonneren',
  footer_email_placeholder: 'Uw e-mailadres',
  footer_contact: 'Contact',
  footer_phone: 'Telefoon',
  footer_email: 'E-mail',
  footer_address: 'Adres',
  footer_rights: 'Alle rechten voorbehouden',
  footer_privacy: 'Privacybeleid',
  footer_terms: 'Servicevoorwaarden',
  footer_cookies: 'Cookiebeleid',
  
  // Common Actions
  learn_more: 'Meer Informatie',
  get_started: 'Aan de Slag',
  contact_us: 'Neem Contact Op',
  view_all: 'Bekijk Alles',
  read_more: 'Lees Meer',
  submit: 'Verzenden',
  send: 'Versturen',
  close: 'Sluiten',
  
  // Common Terms
  home: 'Home',
  products: 'Producten',
  services: 'Diensten',
  solutions: 'Oplossingen',
  about: 'Over Ons',
  contact: 'Contact',
  careers: 'Carrières',
  support: 'Ondersteuning',
};

export default common;
